import { FilterOption } from '@/models/gen/graphql';
import { GetCharitiesDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

const [, runGetCharities] = graphApi(GetCharitiesDocument);

export const getCharities = async (): Promise<Array<FilterOption>> => {
  const res = await runGetCharities();
  return res?.getFilters?.filters?.charities;
};

export const useGetCharities = createGraphApiHook(getCharities);
